<template>
  <div class="login-form-container">
    <h1 class="login-form-card-title">Resend unlock instructions</h1>
    <p v-if="hasErrors" class="has-error" :style="{ marginTop: '4px' }">
      <span v-for="error in errors" :key="error" class="ant-form-explain">
        {{ error }}
      </span>
    </p>
    <a-form
      ref="unlockUserForm"
      layout="vertical"
      :form="form"
      :action="unlockUrl"
      method="POST"
      :style="{ marginBottom: '4px' }"
      @submit.stop.prevent="handleSubmit"
    >
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <a-form-item>
        <span slot="label">Email</span>
        <a-input
          v-decorator="[
            'email',
            {
              rules: [
                {
                  type: 'email',
                  required: true,
                  message: 'Please enter a valid email address',
                },
              ],
            },
          ]"
          name="user[email]"
          autoFocus
        />
      </a-form-item>
      <a-button name="commit" type="primary" htmlType="submit">
        Resend
      </a-button>
    </a-form>
    <div>
      <a :href="sessionUrl">Log in </a>
    </div>
    <div>
      <a :href="ssoUrl">Log in with SSO</a>
    </div>
    <div>
      <a :href="passwordUrl">Forgot your password?</a>
    </div>
  </div>
</template>

<script>
import csrf from "@/lib/csrf.js";

export default {
  props: {
    urls: {
      type: Object,
      required: true,
      validator: (urls) => {
        return (
          typeof urls.password === "string" &&
          typeof urls.unlock === "string" &&
          typeof urls.session === "string" &&
          typeof urls.users === "object"
        );
      },
    },
    errors: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      form: this.$form.createForm(this, {
        name: "unlockUserForm",
        onValuesChange: this.handleFormChange,
      }),
    };
  },

  computed: {
    csrfToken() {
      return csrf.token;
    },
    sessionUrl() {
      return this.urls.session;
    },
    ssoUrl() {
      return this.urls.users.sso;
    },
    unlockUrl() {
      return this.urls.unlock;
    },
    passwordUrl() {
      return this.urls.password;
    },
    hasErrors() {
      return this.errors.length > 0;
    },
  },

  methods: {
    handleSubmit() {
      this.form.validateFields(async (err) => {
        if (!err) {
          // Instead of submitting this through axios, we are doing a regular form submission here.
          // This is because Devise will return a 302 Found, and redirect us to the login page.
          // Devise also flashes a helpful message letting you know that you can expect to receive an email
          // but axios swallows that message.
          this.$refs.unlockUserForm.$el.submit();
        }
      });
    },
  },
};
</script>

<style scoped>
@import "../../sessions/login.css";
</style>
